<template>
    <d2-container>
        <el-form :model="form" :rules="rules" ref="form" label-width="200px">
          <AddTaskItem :value="form"
                       @input="value => form = value"></AddTaskItem>
<!--            <el-form-item label="标题" prop="title">-->
<!--                <el-input v-model="form.title" placeholder="请输入标题" :clearable="true"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="副标题" prop="subtitle">-->
<!--                <el-input v-model="form.subtitle" placeholder="请输入副标题" :clearable="true"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="限制参与证书" prop="certIds">-->
<!--                <el-select class="filter-item" multiple v-model="form.certIds" placeholder="请选择限制参与证书">-->
<!--                    <el-option v-for="item in certIdList" :key="item.id" :label="item.name"-->
<!--                               :value="item.id"></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="分类" prop="classifyId">-->
<!--                <el-select class="filter-item" v-model="form.classifyId" clearable placeholder="请选择分类">-->
<!--                    <el-option-->
<!--                            v-for="item in classifyList"-->
<!--                            :key="item.key"-->
<!--                            :label="item.value"-->
<!--                            :value="item.key"-->
<!--                    ></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="标签">-->
<!--                <el-select class="filter-item" v-model="form.tagIds" multiple placeholder="请选择标签">-->
<!--                    <el-option v-for="item in tagIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="排序(排序越大越靠后)">-->
<!--                <el-input v-model="form.sort" placeholder="请输入排序" :clearable="true" style="width:217px"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="主题色" required prop="color">-->
<!--                <el-color-picker v-model="form.color" size="mini"></el-color-picker>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否公开" required prop="isPublic">-->
<!--                <el-radio-group v-model="form.isPublic">-->
<!--                    <el-radio :label="1">是</el-radio>-->
<!--                    <el-radio :label="0">否</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否上架" required prop="status">-->
<!--                <el-radio-group v-model="form.status">-->
<!--                    <el-radio :label="1">是</el-radio>-->
<!--                    <el-radio :label="0">否</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="类型" required prop="type">-->
<!--                <el-radio-group v-model="form.type">-->
<!--                    <el-radio :label="0">恋爱</el-radio>-->
<!--                    <el-radio :label="1">委托</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="时间类型" required prop="timeType">-->
<!--                <el-radio-group v-model="form.timeType">-->
<!--                    <el-radio :label="0">指定时间</el-radio>-->
<!--                    <el-radio :label="1">动态时间</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="开始时间" required prop="startTime" v-if=" form.timeType == 0">-->
<!--                <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"></el-date-picker>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="结束时间" required prop="endTime" v-if=" form.timeType == 0">-->
<!--                <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间"></el-date-picker>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="保持时间(天)" prop="holdTime" v-if=" form.timeType == 1">-->
<!--                <el-input v-model.number="form.holdTime" placeholder="请输入保持时间(天)" :clearable="true"></el-input>-->
<!--            </el-form-item>-->
<!--            &lt;!&ndash; <el-form-item label="参与人数" prop="numOfPeople">-->
<!--              <el-input v-model.number="form.numOfPeople" placeholder="请输入参与人数" :clearable="true"></el-input>-->
<!--            </el-form-item>&ndash;&gt;-->
<!--            <el-form-item label="可发起次数" prop="limitCount">-->
<!--                <el-input v-model.number="form.limitCount" placeholder="请输入可发起次数" :clearable="true"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="情景图像">-->
<!--                <uploadImg v-model="drawingImgs" :max="20" :text="['图片大小500kb以内']"></uploadImg>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="图标" required prop="icon">-->
<!--                <uploadImg v-model="form.icon" :max="1" :text="['图片大小500kb以内']"></uploadImg>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="详情背景图" prop="infoBack">-->
<!--                <uploadImg v-model="form.infoBack" :max="1" :text="['图片大小500kb以内']"></uploadImg>-->
<!--            </el-form-item>-->

<!--            <el-form-item-->
<!--                    label="规则详情"-->
<!--                    required-->
<!--                    prop="details"-->
<!--                    :rules="[-->
<!--      { required: true, message: '规则详情不能为空', trigger: 'blur' },-->
<!--    ]"-->
<!--            >-->
<!--                <div class="ql-editor">-->
<!--                    <quill-editor-->
<!--                            ref="myQuillEditor"-->
<!--                            v-model="form.details"-->
<!--                            :options="editorOption"-->
<!--                            @blur="onEditorBlur($event)"-->
<!--                            @focus="onEditorFocus($event)"-->
<!--                            @ready="onEditorReady($event)"-->
<!--                    />-->
<!--                    <div class="simulator infinite-list-wrapper" style="overflow:auto">-->
<!--                        <div style="word-wrap: break-word; word-break: normal; " v-html="form.details">-->

<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </el-form-item>-->
<!--            <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">-->
<!--                <div-->
<!--                        style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "-->
<!--                >子任务区域-->
<!--                </div>-->
<!--                <el-collapse accordion>-->
<!--                    <el-collapse-item v-for="(item, index) in form.tasks" :key="index">-->
<!--            <span-->
<!--                    style="font-size:14px;font-weight:600; margin:20px;"-->
<!--                    slot="title"-->
<!--            >子任务{{ index + 1 }}, [标题： {{ item.title }}]</span>-->
<!--                        <el-form-item-->
<!--                                label="标题"-->
<!--                                :prop="'tasks.' + index + '.title'"-->
<!--                                :rules="[-->
<!--      { required: true, message: '标题不能为空', trigger: 'blur' },-->
<!--    ]"-->
<!--                        >-->
<!--                            <el-input v-model="item.title" placeholder="标题" :clearable="true"></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                                label="步骤"-->
<!--                                required-->
<!--                                :prop="'tasks.' + index + '.step'"-->
<!--                                :rules="[-->
<!--      { required: true, message: '步骤不能为空', trigger: 'blur' },-->
<!--      { type: 'number', message: '步骤必须为数字值' },-->
<!--          { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}-->
<!--    ]"-->
<!--                        >-->
<!--                            <el-input v-model.number="item.step" placeholder="请输入步骤" :clearable="true"></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="类型" required :prop="'tasks.' + index + '.autoAudit'">-->
<!--                            <el-radio-group v-model="item.type">-->
<!--                                <el-radio :label="0">图文</el-radio>-->
<!--                                <el-radio :label="1">销售</el-radio>-->
<!--                            </el-radio-group>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="销售单" v-if="item.type === 1">-->
<!--                            <el-select v-model="item.verificationOrderId" filterable placeholder="请选择">-->
<!--                                <el-option-->
<!--                                        reserve-keyword-->
<!--                                        v-for="option in verificationOrderOption"-->
<!--                                        :key="option.key"-->
<!--                                        :label="option.value"-->
<!--                                        :value="option.key">-->
<!--                                </el-option>-->

<!--                            </el-select>-->
<!--                          <el-link style="margin-left: 10px" @click="$router.push('/demo/veriOrder/edit')" type="primary">新建销售单</el-link>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="自动审核" required :prop="'tasks.' + index + '.autoAudit'">-->
<!--                            <el-radio-group v-model="item.autoAudit">-->
<!--                                <el-radio :label="1">开启</el-radio>-->
<!--                                <el-radio :label="0">关闭</el-radio>-->
<!--                            </el-radio-group>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="开始前回复">-->
<!--                            <el-select-->
<!--                                    v-model="item.preReplyId"-->
<!--                                    filterable-->
<!--                                    remote-->
<!--                                    reserve-keyword-->
<!--                                    placeholder="搜素关键词"-->
<!--                                    :remote-method="getKeywordList"-->
<!--                            >-->
<!--                                <el-option-->
<!--                                        v-for="option in keywordList"-->
<!--                                        :key="option.key"-->
<!--                                        :label="option.value"-->
<!--                                        :value="option.key"-->
<!--                                />-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="提交后回复">-->
<!--                            <el-select-->
<!--                                    v-model="item.afterReplyId"-->
<!--                                    filterable-->
<!--                                    remote-->
<!--                                    reserve-keyword-->
<!--                                    placeholder="搜素关键词"-->
<!--                                    :remote-method="getKeywordList"-->
<!--                            >-->
<!--                                <el-option-->
<!--                                        v-for="option in keywordList"-->
<!--                                        :key="option.key"-->
<!--                                        :label="option.value"-->
<!--                                        :value="option.key"-->
<!--                                />-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="封面图" :prop="'tasks.' + index + '.cover'">-->
<!--                            <uploadImg v-model="item.cover" :max="1" :text="['图片大小500kb以内']"></uploadImg>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="规则详情" :prop="'tasks.' + index + '.ruleInfo'">-->
<!--                            <div class="ql-editor">-->
<!--                                <quill-editor-->
<!--                                        ref="myQuillEditor"-->
<!--                                        v-model="item.ruleInfo"-->
<!--                                        :options="editorOption"-->
<!--                                        @blur="onEditorBlur($event)"-->
<!--                                        @focus="onEditorFocus($event)"-->
<!--                                        @ready="onEditorReady($event)"-->
<!--                                />-->
<!--                                <div class="simulator infinite-list-wrapper" style="overflow:auto">-->
<!--                                    <div style="word-wrap: break-word; word-break: normal; " v-html="item.ruleInfo">-->

<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="推荐商品">-->
<!--                            <el-button type="primary" @click="openDialog(index)">选择商品</el-button>-->
<!--                            <el-button type="danger" @click="batchDelete(item,index)">批量删除</el-button>-->
<!--                            <el-table-->
<!--                                    size="small"-->
<!--                                    :key="tableKey"-->
<!--                                    :data="item.marketingGoodsIds"-->
<!--                                    ref="tableRef"-->
<!--                                    stripe-->
<!--                                    border-->
<!--                                    highlight-current-row-->
<!--                                    style="max-width: 1450px;margin-top: 20px"-->
<!--                            >-->
<!--                                <el-table-column align="center" label width="180" type="selection"></el-table-column>-->
<!--                                <el-table-column align="center" label="id" width="180">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <span>{{ scope.row.id }}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column width="300" align="center" label="商品标题">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <span>{{ scope.row.title }}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column width="245" align="center" label="副标题">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <span>{{ scope.row.viceTitle }}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column width="160" align="center" label="商品封面">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <img :src="scope.row.cover" style="width:80px;height:80px;object-fit: cover"/>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column width="120" align="center" label="出售价">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <span>{{ scope.row.price }}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column width="120" align="center" label="市场价">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <span>{{ scope.row.maxPrice }}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column label="操作" align="center">-->
<!--                                    <template slot-scope="{ row,$index }">-->
<!--                                        <el-button-->
<!--                                                type="danger"-->
<!--                                                size="mini"-->
<!--                                                @click="removeGoodsList(index,row,$index)"-->
<!--                                        >删除-->
<!--                                        </el-button>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                            </el-table>-->
<!--                        </el-form-item>-->
<!--                        <div-->
<!--                                style="border:1px solid #DCDFE6;width:98%;padding:0 0 20px 0;margin: 0px auto;margin-bottom: 20px;"-->
<!--                        >-->
<!--                            <div style="text-align: center;margin: 20px auto;">任务奖励</div>-->
<!--                            <div v-for="(item2, index2) in item.gifts" :key="index2" style="margin-top: 20px;">-->

<!--                                <el-collapse accordion>-->
<!--                                    <el-collapse-item>-->
<!--                    <span-->
<!--                            style="font-size:14px;font-weight:600; margin:20px;padding-left:110px"-->
<!--                            slot="title"-->
<!--                    >-->
<!--                      奖品({{ index2 }}):{{ item2.name }}-->
<!--                      <i class="header-icon el-icon-info" style="margin-left: 10px;"></i>-->
<!--                    </span>-->
<!--                                        <el-form-item-->
<!--                                                label="奖品名称"-->
<!--                                                required-->
<!--                                                :rules="{ required: true, message: '请输入奖品名称', trigger: 'blur' }"-->
<!--                                                :prop="'tasks.'+index+'.gifts.'+index2+'.name'"-->
<!--                                        >-->
<!--                                            <el-input v-model="item2.name" placeholder="请输入奖品名称"-->
<!--                                                      :clearable="true"></el-input>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                                label="奖品数量"-->
<!--                                                required-->
<!--                                                :prop="'tasks.'+index+'.gifts.'+index2+'.count'"-->
<!--                                                :rules="[-->
<!--      { required: true, message: '奖品数量不能为空', trigger: 'blur' },-->
<!--      { type: 'number', message: '奖品数量必须为数字值' },-->
<!--          { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}-->
<!--    ]"-->
<!--                                        >-->
<!--                                            <el-input v-model.number="item2.count" placeholder="请输入奖品数量"-->
<!--                                                      :clearable="true"></el-input>-->
<!--                                        </el-form-item>-->

<!--                                        <el-form-item label="获得方式">-->
<!--                                            <el-radio-group v-model="item2.getWay">-->
<!--                                                <el-radio :label="0">审核通过</el-radio>-->
<!--                                                <el-radio :label="1">指定质量</el-radio>-->
<!--                                            </el-radio-group>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item v-if="item2.getWay == 1">-->
<!--                                            从-->
<!--                                            <el-rate show-text v-model="item2.starStart"></el-rate>-->
<!--                                            至-->
<!--                                            <el-rate show-text v-model="item2.starEnd"></el-rate>-->
<!--                                        </el-form-item>-->

<!--                                        <el-form-item-->
<!--                                                label="奖品Icon"-->
<!--                                                :prop="'tasks.'+index+'.gifts.'+index2+'.icon'"-->
<!--                                                :rules="[-->
<!--                          { required: true, message: '奖品Icon不能为空', trigger: 'blur' },-->
<!--                        ]"-->
<!--                                        >-->
<!--                                            <uploadImg-->
<!--                                                    v-model="item2.icon"-->
<!--                                                    :max="1"-->
<!--                                                    :text="['图片大小500kb以内', '图片格式png/jpg/gif','图片宽度48px,高度39px']"-->
<!--                                            ></uploadImg>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                                label="任务已完成的图标"-->
<!--                                                :prop="'tasks.'+index+'.gifts.'+index2+'.defaultIcon'"-->
<!--                                                :rules="[-->
<!--                          { required: true, message: '任务已完成的图标不能为空', trigger: 'blur' },-->
<!--                        ]"-->
<!--                                        >-->
<!--                                            <uploadImg-->
<!--                                                    v-model="item2.defaultIcon"-->
<!--                                                    :max="1"-->
<!--                                                    :text="['图片大小500kb以内', '图片格式png/jpg/gif','图片宽度48px,高度39px']"-->
<!--                                            ></uploadImg>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                                label="列表图标"-->
<!--                                                :prop="'tasks.'+index+'.gifts.'+index2+'.listIcon'"-->
<!--                                                :rules="[-->
<!--                          { required: true, message: '列表图标不能为空', trigger: 'blur' },-->
<!--                        ]"-->
<!--                                        >-->
<!--                                            <uploadImg-->
<!--                                                    v-model="item2.listIcon"-->
<!--                                                    :max="1"-->
<!--                                                    :text="['图片大小500kb以内', '图片格式png/jpg/gif','图片宽度45px,高度45px']"-->
<!--                                            ></uploadImg>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item label="类型" required>-->
<!--                                            <prizeType-->
<!--                                                    @skuType="skuTypes"-->
<!--                                                    @getselect="getselects"-->
<!--                                                    :prizeindex="index2"-->
<!--                                                    :prizesindex="index"-->
<!--                                                    :type="item2.type"-->
<!--                                                    :prizeval="item2.value"-->
<!--                                            ></prizeType>-->
<!--                                        </el-form-item>-->
<!--                                    </el-collapse-item>-->
<!--                                </el-collapse>-->
<!--                                <div style="display: flex;justify-content: center;">-->
<!--                                    <el-button-->
<!--                                            type="danger"-->
<!--                                            size="mini"-->
<!--                                            @click="removePrize(index,index2)"-->
<!--                                            v-if="index2 !== 0"-->
<!--                                    >-删除子任务奖品-->
<!--                                    </el-button>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div style="text-align: center;margin-bottom: 30px;">-->
<!--                            <el-button type="primary" size="mini" @click="addPrize(index)">+增加子任务奖品</el-button>-->
<!--                            <el-button-->
<!--                                    type="danger"-->
<!--                                    size="mini"-->
<!--                                    @click="removeList(index)"-->
<!--                                    v-if="index !== 0"-->
<!--                            >删除子任务-->
<!--                            </el-button>-->
<!--                        </div>-->
<!--                    </el-collapse-item>-->
<!--                    <div style="text-align: center;margin-bottom: 30px;">-->
<!--                        <el-button type="primary" size="mini" @click="addList()">添加子任务</el-button>-->
<!--                    </div>-->
<!--                </el-collapse>-->
<!--            </div>-->
        </el-form>
        <div class="footer" v-if="IncreaseAndChange">
            <el-button @click="cancel('form')">取 消</el-button>
            <el-button type="primary" @click="getCreate('form')">确 定</el-button>
        </div>
        <div class="footer" v-else>
            <el-button @click="cancel('form')">取 消</el-button>
            <el-button type="success" @click="getModify('form')">确 定</el-button>
        </div>
<!--        <commodity-->
<!--                :visible.sync="dlGoodsShow"-->
<!--                :select-list.sync="dialogGoodsList"-->
<!--                @on-select="onSelect"-->
<!--        ></commodity>-->
    </d2-container>
</template>

<script>
// toolbar标题
import { replyKeywordOption } from '@/api/demo/helper'
import prizeType from '@/components/prizeType'
import { mapGetters } from 'vuex'
import { certList } from '@/api/demo/close'
import { getList, getTagys } from '@/api/demo/task'
import uploadImg from '@/components/uploadImage'
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { getToken } from '@/api/demo/classification'
import moment from 'moment'
import {
  getAddActivity,
  getThemeInfo,
  getThemeUpdate,
  getOptions
} from '@/api/demo/punchInActivity'
import commodity from '../../../../components/commodity/shop.vue'
import { getSpuList } from '@/api/demo/commodity'
import draggable from 'vuedraggable'
import { megagameList } from '@/api/demo/competition'
import { addThemeTpl, getThemeTplInfo, getThemeTplUpdate } from '@/api/demo/punchInActivityTpl'
import { getVeriOrderInfo, getVeriOrderOption } from '@/api/demo/veriOrder'
import AddTaskItem from '@/components/project/AddTaskItem.vue'

const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  {
    Choice: '.ql-align .ql-picker-item[data-value="center"]',
    title: '居中对齐'
  },
  {
    Choice: '.ql-align .ql-picker-item[data-value="right"]',
    title: '居右对齐'
  },
  {
    Choice: '.ql-align .ql-picker-item[data-value="justify"]',
    title: '两端对齐'
  }
]

Quill.register('modules/ImageExtend', ImageExtend)

export default {
  name: 'addThemeTpl',
  components: {
    AddTaskItem,
    uploadImg,
    quillEditor,
    commodity, // 商品选择组件
    draggable,
    prizeType
  },
  data () {
    return {
      serviceItemId: null,
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      https: null,
      verificationOrderOption: [],
      beforeArr: [], // 情景图
      beforeArr2: [], // 情景图
      drawingImg: '', // 情景图
      drawingImgs: [], // 情景图
      dataList2: [], // 情景图
      dataList: [], // 情景图
      /** 模板配置 */
      tplOptions: {
        sort: true
      },
      dlGoodsShow: false, // 选择商品
      dialogGoodsList: [], // 弹窗商品列表
      tableKey: 0,
      listLoading: true, // 加载圈圈
      indexId: null,
      IncreaseAndChange: false, // 判断是新增还是修改
      activity: null, // 修改需要的活动id
      infoBack: null, // 详情背景图
      infoBack2: [], // 详情背景图
      keywordList: [],
      form: {
        title: '', // 标题
        subtitle: '', // 副标题
        certIds: [], // 限制参与证书
        classifyId: '', // 分类id
        tagIds: [], // 标签id
        sort: '',
        isPublic: 1, // 是否公开 1 公开 0 不公开
        holdTime: '', // 保持时间
        timeType: 0, // 时间类型 0 指定时间 1 动态时间
        status: 0, // 0 未上架 1 已上架
        type: 0, // 0 正常 1委托
        // numOfPeople: null, //参与人数
        limitCount: null, // 可发起次数
        details: null, // 详细说明
        icon: '', // 图标
        icon2: [], // 图标
        color: '', // 主题色
        story: '', // 情景故事
        storyArr: [], // 情景故事
        startTime: '',
        endTime: '',
        tasks: [
          {
            verificationOrderId: null,
            type: 0, // 0 图文 1 销售
            cover: '', // 封面图
            cover2: [], // 封面图
            autoAudit: 0,
            preReplyId: null,
            afterReplyId: null,
            gifts: [
              {
                name: '', // 奖品名称
                count: '', // 数量
                icon: '', // 奖品图标
                icon3: [], // 奖品图标
                getWay: 0, // 获得方式
                starEnd: 1, // 星级结束
                starStart: 1, // 星级开始
                defaultIcon: '', // 默认图标
                defaultIcon2: [], // 默认图标
                type: 0, // 类型0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会 6勋章
                value: '', // 虚拟物品值
                value2: '',
                getCardList: [], // 卡片集合
                listIcon: '', // 列表图标
                listIcon2: [] // 列表图标
              }
            ], // 奖品集合
            marketingGoodsIds: [], // 推荐商品
            markList: [], // 商品id
            ruleInfo: '', // 规则详情
            step: '', // 步骤
            title: '' // 标题
          }
        ],
        goodsIds: []
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        subtitle: [
          {
            required: true,
            message: '请输入副标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        classifyId: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ],
        certIds: [
          { required: true, message: '请选择限制参与证书', trigger: 'change' }
        ],
        // tagIds: [{ required: true, message: "请选择标签", trigger: "change" }],
        // numOfPeople: [
        //   { required: true, message: "参与人数不能为空" },
        //   { type: "number", message: "参与人数必须为数字值" },
        //   {
        //     pattern: /^[1-9]+[0-9]*$|^0$/,
        //     message: "非负整数（正整数 + 0）",
        //     trigger: "blur"
        //   }
        // ],
        limitCount: [
          { required: true, message: '可发起次数不能为空' },
          { type: 'number', message: '可发起次数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        holdTime: [
          { required: true, message: '保持时间不能为空' },
          { type: 'number', message: '保持时间必须为数字值' },
          {
            pattern: /^\+?[1-9]\d*$/,
            message: '大于0的正整数',
            trigger: 'blur'
          }
        ]
      },
      certIdList: [], // 证书集合
      classifyList: [], // 分类集合
      tagIdList: [], // 标签集合
      listQuery: {
        currentPage: 1,
        pageSize: 40
      },
      listshopQuery: {
        currentPage: 1,
        goodsId: '',
        goodsIds: [],
        pageSize: 20,
        keyword: '',
        state: '', // 产品状态
        categoryId: '' // 产品分类
      },
      getKeywordList (keyword) {
        let that = this
        let query = { 'keyword': keyword }
        replyKeywordOption(query).then(res => {
          that.keywordList = res
        }).finally(() => {
        })
      },

      // 富文本框参数设置
      editorOption: {
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            //   size: 2,
            action: 'https://up-z2.qiniup.com',
            response: res => {
              return this.https + '/' + res.key
            },
            change: (xhr, formData) => {
              formData.append('token', this.uploadData.token)
              formData.append('key', `upload_pic_${new Date().getTime()}`)
            }
          },
          toolbar: {
            container: container,
            handlers: {
              image: function (value) {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      nameId: ''
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  watch: {
    $route (to, from) {
    }
  },
  created () {
    let that = this
    that.getSearch() // 证书集合
    that.getClassList() // 分类集合
    that.gettagIdList() // 标签集合
    that.getKeywordList()
    this.getVerificationOrderOption()
    // that.initTitle();

    let id = that.$route.query.id
    console.log(id, 'id')
    that.nameId = that.$route.query.name
    that.activity = that.$route.query.id
    this.serviceItemId = this.$route.query.serviceItemId
    console.log(this.form.serviceItemId, 'this.form.serviceItemId')
    if (id && id !== 'undefined') {
      if (that.nameId === '模板') {
        getThemeTplInfo(id).then(res => {
          that.transitionForm(res)
        })
      } else {
        getThemeInfo(id).then(res => {
          that.transitionForm(res)
        })
      }
      if (that.nameId != undefined) {
        that.IncreaseAndChange = true
      }
    } else {
      that.IncreaseAndChange = true
    }
  },

  mounted () {
    let that = this
    // this.initTitle();
    // that.getAttributes();
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
  },
  methods: {

    getVerificationOrderOption () {
      let that = this
      getVeriOrderOption().then(res => {
        that.verificationOrderOption = res
      })
    },
    transitionForm (res) {
      let that = this
      // for (let index = 0; index < res.tasks.length; index++) {
      //     if (res.tasks[index].marketingGoodsIds.length != 0) {
      //         that.listshopQuery.goodsIds = res.tasks[index].marketingGoodsIds;
      //         getSpuList(that.listshopQuery).then(res2 => {
      //             res.tasks[index].marketingGoodsIds = res2.records;
      //         });
      //     }
      // }
      that.form = res
      // console.log("resinfo", res,that.form.story);
      if (that.form.story != null) {
        that.drawingImgs = that.form.story.split(',')
      }
    },
    getClassList () {
      let that = this
      getOptions().then(res => {
        console.log('megagameClassifyOptions', res)
        that.classifyList = res
      })
    },
    initTitle () {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    getSearch () {
      let that = this
      certList(that.listQuery).then(res => {
        that.listLoading = true
        that.certIdList = res.records
        that.listLoading = false
      })
    },
    gettagIdList () {
      getTagys(this.listQuery).then(res => {
        this.listLoading = true
        this.tagIdList = res.records
        this.listLoading = false
      })
    },
    // 取消
    cancel () {
      let that = this
      // that.$router.push("/demo/punchTheClock");
      //     如果上一页是当前页 则返回两次
      if (that.$route.query.serviceItemId) {
        that.$router.go(-2)
      } else {
        that.$router.go(-1)
      }
    },
    // 新增
    getCreate (forms) {
      let that = this
      const set = this.$refs
      console.log('----getCreate')
      set[forms].validate(valid => {
        console.log('----getCreate validate')
        if (valid) {
          // that.form.startTime = moment(that.form.startTime).format(
          //     "YYYY-MM-DD HH:mm:ss"
          // );
          that.form.endTime = moment(that.form.endTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.serviceItemId = that.serviceItemId
          let details = that.form.details.replace(
            /(\<img|\<p|\<blockquote|\undefined|\<br>|re |\<\/pre>|\<li |\<iframe|<a href|\><\/a>|\><\/iframe>)/gi,
            that.tpl
          )
          console.log('details', details)
          that.form.details = details
          let str = JSON.stringify(that.form)
          // console.log('str', str)
          let form = JSON.parse(str)
          form.id = null
          for (let index = 0; index < form.tasks.length; index++) {
            let task = form.tasks[index]
            task.id = null
            // for (let index1 = 0; index1 < task.gifts.length; index1++) {
            //     let gift = task.gifts[index1];
            //     gift.id = null;
            //     task.gifts[index1] = gift
            // }
            form.tasks[index] = task
          }

          console.log(form, 'form')
          // console.log('form',form)
          for (let index = 0; index < that.form.tasks.length; index++) {
            form.tasks[index].ruleInfo = JSON.parse(
              JSON.stringify(
                that.form.tasks[index].ruleInfo.replace(
                  /(\<img|\<p|\<blockquote|\undefined|\<br>|re |\<\/pre>|\<li |\<iframe|<a href|\><\/a>|\><\/iframe>)/gi,
                  that.tpl
                )
              )
            )
            // 只保留id
            // let markList = [];
            // for (
            //     let index4 = 0;
            //     index4 < form.tasks[index].marketingGoodsIds.length;
            //     index4++
            // ) {
            //     markList.push(
            //         form.tasks[index].marketingGoodsIds[index4].id
            //     );
            //     // console.log('that.form.tasks[index].marketingGoodsIds[index4].id',that.form.tasks[index].markList,that.form.tasks[index].marketingGoodsIds[index4].id)
            // }
            // form.tasks[index].marketingGoodsIds = markList;
          }

          getAddActivity(form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            // that.$router.push("/demo/punchTheClock");
            if (that.$route.query.serviceItemId) {
              that.$router.go(-2)
            } else {
              that.$router.go(-1)
            }
          })
          console.log('form', that.form)
        } else {
          return false
        }
      })
    },
    // 修改
    getModify (forms) {
      let that = this
      const set = this.$refs
      set[forms].validate(valid => {
        if (valid) {
          // that.form.startTime = moment(that.form.startTime).format(
          //     "YYYY-MM-DD HH:mm:ss"
          // );
          that.form.endTime = moment(that.form.endTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          let details = that.form.details.replace(
            /(\<img|\<p|\<blockquote|\undefined|\<br>|re |\<\/pre>|\<li |\<iframe|<a href|\><\/a>|\><\/iframe>)/gi,
            that.tpl
          )
          console.log('details', details)
          that.form.details = details
          let str = JSON.stringify(that.form)
          // console.log('str', str)
          let form = JSON.parse(str)
          // console.log('form',form)
          for (let index = 0; index < that.form.tasks.length; index++) {
            form.tasks[index].ruleInfo = JSON.parse(
              JSON.stringify(
                that.form.tasks[index].ruleInfo.replace(
                  /(\<img|\<p|\<blockquote|\undefined|\<br>|re |\<\/pre>|\<li |\<iframe|<a href|\><\/a>|\><\/iframe>)/gi,
                  that.tpl
                )
              )
            )

            let markList = []
            // 只保留id
            // for (
            //     let index4 = 0;
            //     index4 < form.tasks[index].marketingGoodsIds.length;
            //     index4++
            // ) {
            //     markList.push(
            //         form.tasks[index].marketingGoodsIds[index4].id
            //     );
            // }
            // form.tasks[index].marketingGoodsIds = markList;
          }
          console.log('that.form222--', form)
          getThemeUpdate(form, that.activity).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            // that.$router.push("/demo/punchTheClock");
            that.$router.back()
          })
        } else {
          return false
        }
      })
    },
    tpl ($0, $1) {
      return {
        're ': '><pre ',
        '</pre>': '</pre>',
        // "<p": '<p style="line-height:30px;"',
        '<p':
                    '<p style="line-height:30px;display:flex;justify-content:space-around" ',
        // text-indent:1em;
        '<img': '<img style="max-width:100%;height:auto;margin:5px 0;display:flex;justify-content:center;text-align:center" ',
        '<iframe': '<video controls="controls" style = "width:100%" ',
        '<blockquote':
                    '<blockquote style="border-left: 4px solid #ccc;margin-bottom: 5px;margin-top: 5px;padding-left: 16px;" ',
        undefined: '',
        '<br>': "<div style='width: 100%'></div>",
        '<a href': `<a style="color:blue;cursor: pointer;" href`,
        '></a>': '/></a>',
        '></iframe>': '/></video>'
      }[$1]
    },
    onEditorBlur (quill) {
      console.log('editor blur!', this.form.content, quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', this.form.content, quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    },
    // 选择商品
    openDialog (index) {
      this.indexId = index
      this.dlGoodsShow = true
      this.dialogGoodsList = this.form.tasks[index].marketingGoodsIds // 勾选回选
    },
    // 商品批量删除
    async batchDelete (item, curIdx) {
      console.log(
        'this.$refs.tableRef.selection',
        this.$refs.tableRef[curIdx].selection
      )
      if (!this.$refs.tableRef[curIdx].selection.length) {
        this.$message.error('请勾选要删除的商品')
        return
      }
      var seid = this.$refs.tableRef[curIdx].selection
      let itmu = item.marketingGoodsIds
      for (let i = 0; i < seid.length; i++) {
        for (let y = 0; y < itmu.length; y++) {
          if (JSON.stringify(itmu[y]) == JSON.stringify(seid[i])) {
            // 判断是否相等，相等就删除
            this.form.tasks[curIdx].marketingGoodsIds.splice(y, 1)
          }
        }
      }
    },
    // 商品弹窗确认选择
    async onSelect () {
      let that = this
      let marketingGoodsIds = this.form.tasks[this.indexId].marketingGoodsIds
      let newGoodsList = this.dialogGoodsList.filter(
        item => !marketingGoodsIds.some(ele => ele.id === item.id)
      ) // 新数组
      newGoodsList.forEach(v => {
        this.$set(v, 'sort', 10)
      })

      marketingGoodsIds = [...marketingGoodsIds, ...newGoodsList] // 商品
      console.log(marketingGoodsIds, 'marketingGoodsIdsmarketingGoodsIds')
      this.form.tasks[this.indexId].marketingGoodsIds = marketingGoodsIds
      console.log('marketingGoodsIds', this.form.tasks[this.indexId])
    },
    // 删除商品
    removeGoodsList (i, row, index) {
      this.form.tasks[i].marketingGoodsIds.splice(index, 1)
    },
    // 点击添加
    addList () {
      this.form.tasks.push({
        cover: '', // 封面图
        cover2: [], // 封面图
        autoAudit: 0,
        preReplyId: null,
        afterReplyId: null,
        gifts: [
          {
            name: '', // 奖品名称
            count: '', // 数量
            icon: '', // 奖品图标
            icon3: [], // 奖品图标
            type: 0, // 类型0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会
            value: '', // 虚拟物品值
            value2: '',
            getCardList: [], // 卡片集合
            defaultIcon: '', // 默认图标
            listIcon: '' // 列表图标
          }
        ], // 奖品集合
        marketingGoodsIds: [], // 推荐商品
        markList: [], /// /推荐商品id
        ruleInfo: '', // 规则详情
        step: '', // 步骤
        title: '' // 标题
      })
    },
    // 删除
    removeList (index) {
      this.form.tasks.splice(index, 1)
      this.form.tasks.forEach((item, index) => {
        item.index = index
      })
    },
    // 新增奖品
    addPrize (index) {
      this.form.tasks[index].gifts.push({
        name: '', // 奖品名称
        count: '', // 数量
        icon: '', // 奖品图标
        icon3: [], // 奖品图标
        type: 0, // 类型0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会
        value: '', // 虚拟物品值
        value2: '',
        getCardList: [], // 卡片集合
        defaultIcon: '', // 默认图标
        listIcon: '' // 列表图标
      })
      console.log('this.form.tasks[index]', index, this.form.tasks[index])
    },
    // 删除奖品
    removePrize (index, index2) {
      this.form.tasks[index].gifts.splice(index2, 1)
      this.form.tasks[index].gifts.forEach((item3, index3) => {
        item3.index = index3
      })
      console.log('index2', index, index2, this.form.tasks[index])
    },
    // 奖品类型
    skuTypes (val1, val2, val3) {
      let that = this
      // let that = this;
      for (
        let index = 0;
        index < that.form.tasks[val3].gifts.length;
        index++
      ) {
        if (index == val2) {
          console.log('index == val2', index == val2, index)
          that.form.tasks[val3].gifts[index].type = val1
        }
      }
    },
    getselects (val1, val2, val3) {
      let that = this
      for (
        let index = 0;
        index < that.form.tasks[val3].gifts.length;
        index++
      ) {
        if (index == val2) {
          that.form.tasks[val3].gifts[index].value = val1
        }
      }
    },
    // 详情图
    getDetailDrawing (res, file) {
      let that = this
      // 修改上传图片排序问题
      that.beforeArr2.filter((item, index) => {
        if (item.uid === file.uid) {
          // 与正确顺序的UID进行比对，添加进将要上传后台的数组
          that.drawingImg = that.https + '/' + res.key
          that.dataList2.splice(index, 1, that.drawingImg)
        }
      })
      var joo = that.dataList2.concat(that.drawingImgs)
      that.drawingImgs = joo
      that.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < that.drawingImgs.length; i++) {
          if (!obj[that.drawingImgs[i]]) {
            if (that.drawingImgs[i].name) {
            } else {
              result.splice(i, 0, that.drawingImgs[i])
              obj[that.drawingImgs[i]] = true
            }
          }
        }
        that.drawingImgs = result
        that.form.story = that.drawingImgs.join(',')
      })
    },
    beforeAvatarUpload2 (file) {
      this.beforeArr2.push(file)
      this.dataList2.push(file)
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`
    },
    uploadError (err, file) {
      this.$message({
        message: '上传出错，请重试！',
        type: 'error',
        center: true
      })
    },
    // 详情图删除
    getClose (index) {
      this.drawingImgs.splice(index, 1)
      this.dataList2.splice(index, 1)
      this.beforeArr2.splice(index, 1)
      let strings = this.drawingImgs.join(',')
      this.form.story = strings
    },
    // 详情图拖拽
    update2 (e) {
      this.form.story = this.drawingImgs.join(',')
    }
  }
}
</script>
<style scoped>
.footer {
    text-align: center;
}

.ql-editor {
    padding: 0;
}
</style>
